import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from 'lib/api';
import type { MutationConfig } from 'lib/react-query';
import { UpdateMetricsResponse, UpdateMetricsPayload } from './types';
import { isAxiosError } from 'axios';

export const updateMetrics = async (params: UpdateMetricsPayload[]): Promise<UpdateMetricsResponse> => {
  const res = await apiClient.patch<UpdateMetricsResponse>(`/metrics`, { data: params });
  if (isAxiosError(res)) {
    const error = new Error('Update metrics error');
    error.cause = res.response?.data;
    return Promise.reject(error);
  }
  return res.data;
};

interface UseUpdateMetricsOptions {
  config?: MutationConfig<typeof updateMetrics>;
}

export const useUpdateMetrics = ({ config }: UseUpdateMetricsOptions = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...config,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({
        queryKey: ['metrics'],
      });

      if (config?.onSuccess) {
        await config.onSuccess(...args);
      }
    },
    onError: (...args) => {
      if (config?.onError) {
        config.onError(...args);
      }
    },
    mutationFn: updateMetrics,
  });
};
